<template>
    <div>
        <template v-if="pdv==0 || pdv==1">
            <b-row>
                <b-col xl="1">
                    <b-form-select class="colorBorde" v-model="selected" :options="options"></b-form-select>
                </b-col>
                <b-col xl="1">
                    <select  :disabled="tdocdisabled" class="custom-select mr-sm-2 input-placedark input-dark colorBorde" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                        <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                            {{ tipodocumento.nombre }}
                        </option>
                    </select> 
                </b-col>
                <b-col xl="2" >
                    <b-input-group>
                        <b-form-input type="text" :disabled="tipoDocumento==0" class="form-control address colorBorde" v-model="receptor.numero" placeholder="Documento" autofocus @change="getReceivers()"></b-form-input>
                        <!-- <label>Documento</label> -->
                        <b-input-group-text class="colorBorde" slot="append">
                                <b-button size="sm" @click="closeList()" variant="success" class="sinresultados"><i class="fas fa-arrow-up"></i></b-button>
                        </b-input-group-text>
                    </b-input-group>
                    <template v-if="cargandoreceptor">
                    <b-list-group class="searcher-field">
                        <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                    </b-list-group>
                    </template>
                    <b-list-group v-if="listarec" class="searcher-field">
                    <!-- <b-list-group-item v-if="norec">No hay Receptores con ese número</b-list-group-item> -->
                    <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                        <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                        {{item.idReceptor + ' - ' + item.razonSocial}}
                        </b-list-group-item>
                    </template>
                    </b-list-group>
                    <b-list-group v-if="mostrardni" class="searcher-field">
                        <b-list-group-item v-if="norecdni">No hay Receptores con ese número</b-list-group-item>                                 
                        <template >
                            <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                        </template> 
                    </b-list-group>  
                </b-col>
                <b-col xl="2">
                    <div v-if="tipoDocumento != '1'" class="form-label-group">
                        <b-form-input type="text" class="form-control address colorBorde" @input="pitcherReceiver()" v-model="receptor.razonSocial" placeholder="Atencion a" autofocus></b-form-input>
                        <label>Razon Social</label>
                    </div>
                    <div v-else class="form-label-group">
                        <b-form-input type="text" class="form-control address colorBorde" v-model="receptor.razonSocial" placeholder="Atencion a" autofocus></b-form-input>
                        <label>Razon Social</label>
                    </div>
                </b-col>
                <b-col xl="4">
                    <div class="form-label-group">
                        <b-form-input type="text" class="form-control address colorBorde" v-model="receptor.direccion" placeholder="Dirección" autofocus></b-form-input>
                        <label>Dirección</label>
                    </div>
                </b-col>
                <b-col xl="1">
                    <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" v-model="moneda">
                        <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                        {{ moneda.descripcion }}
                        </option>
                    </select>
                </b-col>
                <b-col xl="1">
                    <b-input-group>
                        <template v-if="seriesCargadas">
                        <b-button size="md" variant="secondary" outline-success>
                            Cargando... <i class="fa fa-spin fa-spinner"></i>
                        </b-button>
                        </template>
                        <template v-else>
                        <select class="form-control input-placedark input-dark colorBorde" v-model="indexSerie">
                            <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                        </select>
                        </template>
                    </b-input-group>
                </b-col>
            </b-row><br>
            <b-row>
                <b-col>
                    <div class="lineader">
                        <div class="minimo"> 
                            <b-table 
                                style="position:relative; height:295px; overflow-y:auto"
                                responsive
                                striped 
                                hover
                                small 
                                scrollY
                                scrollX
                                :items="items" 
                                :fields="items_fields" 
                                >
                                <template slot="descripcion" v-if="pdv==1 && row.item.adicional" slot-scope="row">
                                    {{ row.item.descripcion }} - Placa: {{ row.item.adicional.numeroPlacaVehiculo }}
                                </template>
                                <template slot="observacion" slot-scope="row">
                                    {{ row.item.observacion }} || {{ row.item.subopcionSeleccionada }}
                                </template>
                                <template slot="valorVentaVista" v-if="pdv==1 && row.item.adicional" slot-scope="row">
                                    {{ row.item.valorVentaVista.toFixed(2) }}
                                </template>
                                <template slot="acciones" slot-scope="row">
                                    <b-button size="sm" @click="deleteItem(row.index)" variant="danger"><i class="fa fa-trash"></i></b-button>
                                </template>
                            </b-table>
                            <b-row>
                                <b-col>
                                  <b-badge variant="success" style="width:100%"><h5><b>Productos: {{ items.length }}</b></h5></b-badge>
                                </b-col>                             
                            </b-row>
                            <b-row class="mt-3">
                                <b-col>
                                    <h5>Venta Inafecta <br><b> {{moneda.simbolo}} <template v-if="totales.importeTotal">{{ totales.totalVentaInafecta.toFixed(2) }}</template><template v-else>0.00</template></b></h5>
                                </b-col>
                                <b-col>
                                    <h5>Venta Exonerada <br><b> {{moneda.simbolo}} <template v-if="totales.importeTotal">{{ totales.totalVentaExonerada.toFixed(2) }}</template><template v-else>0.00</template></b></h5>
                                </b-col>
                                <b-col>
                                    <h5>Venta Gravada <br><b> {{moneda.simbolo}} <template v-if="totales.importeTotal">{{ totales.totalVentaGravada.toFixed(2) }}</template><template v-else>0.00</template></b></h5>
                                </b-col>
                                <b-col>
                                    <h5>TOTAL <br><b> {{moneda.simbolo}} <template v-if="totales.importeTotal">{{ totales.importeTotal.toFixed(2) }}</template><template v-else>0.00</template></b></h5>
                                </b-col>
                            </b-row>       
                        </div>                      
                        <template v-if="selected == 8 || selected == 11 || selected == 12">
                         <strong>Detalles:</strong>
                            <b-row>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="6">
                                    <b-form-input type="text" class="nombre" placeholder="Atencion a:" v-model="atencion" autofocus></b-form-input>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                    <b-form-input type="text" class="nombre" placeholder="Plazo de entrega:" v-model="plazoentrega" autofocus></b-form-input>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                    <b-form-input type="text" class="nombre" placeholder="Forma de pago:" v-model="tipoPago" autofocus></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col cols="0" sm="0"	md="6"	lg="6"	xl="6">
                                    <b-form-textarea      
                                    v-model="observaciones"
                                    rows="3"
                                    max-rows="6"
                                    placeholder="Observacion General ">
                                    </b-form-textarea>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                    <b-form-input type="text" class="nombre" placeholder="Garantia:" v-model="garantia" autofocus></b-form-input>
                                </b-col>
                                <b-col cols="12" sm="5" md="5" lg="4" xl="3">
                                    <b-form-input type="text" class="nombre" placeholder="Teléfono:" v-model="telefono" autofocus></b-form-input>
                                </b-col> 
                            </b-row>
                            <b-row class="mt-3">
                                <b-col v-if="selected == 11" cols="3">
                                    <select class="custom-select" v-model="tag3">
                                        <option value=""> Seleccione Etiqueta </option>
                                        <option v-for="tag in listaTag" v-if="tag.numeroTag == 3" :key="tag.id" :value="tag">{{ tag.tag }}</option>
                                    </select>
                                </b-col>
                            </b-row>
                        </template>
                        <totales style="display:none" @loadtotal="insertTotal" :items="items" :monedabuffer="moneda" :cargos="listaOtrosCargosAgregados"></totales>
                        <b-row>
                            <!-- <b-col xl="6">
                                <div class="bordes">
                                    <totales style="display:none" @loadtotal="insertTotal" :items="items" :monedabuffer="moneda" :cargos="listaOtrosCargosAgregados"></totales>
                                </div>
                            </b-col> -->
                            <b-col cols="12" sm="10" md="10" lg="10" xl="12">
                                <!-- PDV Comercio | v-if="pdv == 0"  -->
                                <!-- formas de pago -->
                                <div class="letra bordes pagos" v-if="selected != 8 && selected != 11">
                                    <b-row>
                                        <b-col>
                                            <div class="text-center">
                                                <h4><b>FORMAS DE PAGO</b></h4>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="10" md="10" lg="10" xl="6">
                                            <b-input-group>
                                                <b-button v-if="formadepago.codigo =='00'"  v-b-tooltip.hover="'ver cuotas crédito'" style="border:none" variant="outline-primary" class="sinresultados mr-1" size="sm" @click="vercreditos()"><i class="fas fa-eye"></i></b-button>
                                                <select class="letra custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                                                    <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                                                    {{ fpago.nombre }}
                                                    </option>
                                                </select>
                                             </b-input-group>
                                        </b-col>
                                        <b-col cols="12" sm="10" md="10" lg="10" xl="4">
                                            <b-form-input class="letra" placeholder="0.00" v-model="fpago" @keyup.enter="addPago()"></b-form-input>
                                        </b-col>
                                        <b-col v-if="pdv==1" cols="12" sm="10" md="10" lg="10" xl="2">
                                            <template v-if="selected == 1">
                                                <div>
                                                    <b-form-select :disabled="this.listaPagos.length > 0 ? false:true" v-model="selectedRetencion" :options="optionsIgv"></b-form-select>
                                                </div>
                                            </template>
                                        </b-col>
                                    </b-row><br>
                                    <b-row>
                                        <b-col xl="12">
                                            <b-list-group>
                                                <b-list-group-item v-for="(pago, index) of listaPagos" :key="index">
                                                    <b-row>
                                                        <b-col xl="7">
                                                            {{ pago.descripcion.substring(0,54) }}...
                                                        </b-col>
                                                        <b-col xl="1">
                                                            {{ moneda.simbolo }}
                                                        </b-col>
                                                        <b-col xl="3">
                                                            {{ pago.monto }}
                                                        </b-col>
                                                        <b-col xl="1">
                                                            <i @click="removePago(index)" class="fa fa-times-circle text-danger"></i>
                                                        </b-col>      
                                                    </b-row> 
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-col>
                                    </b-row>
                                    <hr>
                                    <b-row>
                                        <b-col xl="6">
                                            <b>Pagos</b>
                                        </b-col>
                                        <b-col xl="1">
                                            {{ moneda.simbolo }}
                                        </b-col>
                                        <b-col xl="4">
                                            {{ accumulatePagos() }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col xl="6">
                                            <b>Vuelto</b>
                                        </b-col>
                                        <b-col xl="1">
                                            {{ moneda.simbolo }}
                                        </b-col>
                                        <b-col xl="4">
                                            {{ vuelto.toFixed(2) }}
                                        </b-col>
                                    </b-row>
                                    <hr>
                                    <b-row class="mt-3"> 
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago con Yape" class="formasPagosImg" src="images/yape.png" @click="pagosImg(1)"><b-badge v-if="colorPago1" style="color:green">Yape</b-badge><p v-else>Yape</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago con Plin" class="formasPagosImg" src="images/plin.png" @click="pagosImg(2)"><b-badge v-if="colorPago2" style="color:green">Plin</b-badge><p v-else>Plin</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago A Crédito" class="formasPagosImg" src="images/Acredito.png" @click="pagosImg(3)"><b-badge v-if="colorPago3" style="color:green">A crédito</b-badge><p v-else>A crédito</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="T.Débito" class="formasPagosImg" src="images/tDebito.png" @click="pagosImg(4)"><b-badge v-if="colorPago4" style="color:green">T.Débito</b-badge><p v-else>T.Débito</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Pago Efectivo" class="formasPagosImg" src="images/efectivo1.png" @click="pagosImg(5)"><b-badge v-if="colorPago5" style="color:green">Efectivo</b-badge><p v-else>Efectivo</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="T.Crédito" class="formasPagosImg" src="images/tCredito.png" @click="pagosImg(6)"><b-badge v-if="colorPago6" style="color:green">T.Crédito</b-badge><p v-else>T.Crédito</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Depósito en Cuenta" class="formasPagosImg" src="images/depositoCuenta.png" @click="pagosImg(7)"><b-badge v-if="colorPago7" style="color:green">Déposito Cuenta</b-badge><p v-else>Déposito Cuenta</p></b-col>
                                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="2"><img title="Transferencia Bancos" class="formasPagosImg" src="images/transBancos.png" @click="pagosImg(8)"><b-badge v-if="colorPago8" style="color:green">Trans.Fondos</b-badge><p v-else>Trans. Fondos</p></b-col>
                                    </b-row>
                                </div>
                                <!-- Fin formas de pago -->
                            </b-col>
                        </b-row>
                        <br>
                        <b-row>
                            <b-col>
                                <div class="text-right">
                                    <b-button v-b-modal.ticket size="sm" variant="primary" class="mr-4">Imprimir Ticket</b-button>
                                    <b-button v-b-modal.adicionales size="sm" variant="primary" class="mr-4"><i class="fas fa-plus-circle"></i> Datos Adicionales</b-button>
                                    <b-button v-b-modal.cargos size="sm" variant="secondary" :disabled="items.length<=0" class="mr-4"><i class="fa fa-hand-holding-usd"></i> Otros Cargos</b-button>
                                    <b-button size="sm" class="btn btn-success mr-4" @click="nuevaImpresion()" v-if="vistaimpresion"><i class="fas fa-plus"></i> Nuevo</b-button>
                                    <b-button size="sm" variant="warning" class="mr-4" @click="openModal()" v-if="vistaimpresion"><i class="fa fa-print"></i> Vista Impresion</b-button>
                                    <template v-if="selected != 8 && selected !=12  && selected !=11">
                                        <template v-if="totales && totales.importeTotal">
                                            <b-button size="sm" v-if="!emitiendo" variant="primary" :disabled="validTicket()" @click="validarImporteTotal()"><i class="fa fa-paper-plane"></i> Emitir</b-button>
                                            <b-button size="sm" v-else variant="secondary"><i class="fa fa-spin fa-spinner"></i> Emitiendo</b-button>
                                        </template>
                                        <template v-else>
                                            <b-button size="sm" variant="primary" disabled><i class="fa fa-paper-plane"></i> Emitir</b-button>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="selected == 8">
                                            <b-button variant="success" :disabled="validarRuc()" @click="proformasave()">Guardar Proforma</b-button>                                   
                                        </template>
                                        <template v-else-if="selected == 12">
                                            <b-button variant="success" :disabled="validTicket()" @click="sendNotaVenta()"> <i class="fa fa-paper-plane"></i> Guardar Nota Venta</b-button>                                   
                                        </template>   
                                        <template v-else-if="selected == 11">
                                            <b-button variant="success" :disabled="validarRuc()" @click="sendOP()"> <i class="fa fa-paper-plane"></i> Guardar Orden Pago</b-button>                                   
                                        </template>                                    
                                    </template>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col>
                    <b-row>                   
                        <b-col cols="12" sm="10" md="10"	lg="10"	xl="2">
                            <div class="form-label-group">
                                <b-form-input type="text" class="form-control address colorBorde" @change="searchProduct('code')" v-model="busquedacode" placeholder="Buscar por Código" autofocus></b-form-input>
                                <label>Por Código</label>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="10" md="10"	lg="10"	xl="4">
                            <div class="form-label-group">
                                <b-form-input type="text" class="form-control address colorBorde" @change="searchProduct('name')" v-model="busquedaname" placeholder="Buscar por Descripción" autofocus></b-form-input>
                                <label>Buscar por Descripción</label>
                            </div>
                            <!-- <b-form-input placeholder="Buscar por Descripción" @change="searchProduct('name')" v-model="busquedaname"></b-form-input> -->
                        </b-col>
                        <b-col cols="12" sm="10" md="10"	lg="10"	xl="2">
                            <b-button variant="success" v-if="!cargandoproducto" @click="searchProduct()"> Buscar <i class="fa fa-search"></i></b-button>
                            <b-button variant="secondary" v-else> <i class="fa fa-spin fa-spinner"></i></b-button>
                        </b-col>
                        <b-col cols="12" sm="10" md="10"	lg="10"	xl="3">
                            <select class="custom-select colorBorde" v-model="catProducto">
                                <option value=""> Seleccione Etiqueta </option>
                                <option v-for="categoria in listaCategoria"  :key="categoria.id">{{ categoria.descripcion }}</option>
                            </select>
                        </b-col>
                        <b-col cols="1">
                            <div v-if="pdv == 0">
                                <div class="text-center mb-2">
                                <b-button @click="listProductComercio()" title="Actualizar tabla"><i class="fas fa-redo"></i></b-button>
                                </div>            
                             </div>
                             <div v-else-if="pdv == 1" >       
                                <div class="text-center mb-2">
                                    <b-button @click="listProduct()" title="Actualizar tabla"><i class="fas fa-redo"></i></b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row><br>
                    <b-row>
                        <b-col>
                            <div class="scrollItems">
                        <b-table
                            small
                            hover 
                            :items="products" 
                            :fields="products_fields" 
                            :busy="isBusy"
                            outlined
                        >
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template slot="nombrecustom" slot-scope="row">
                            <b-row>
                                <b-col cols="7" class="pr-0">
                                    <div class="form-label-group">
                                        <b-form-input   
                                        class="negrita form-control address colorBorde" 
                                        size="sm" 
                                        v-model="row.item.descripcion">
                                        </b-form-input>
                                        <label>{{ row.item.codigo }}</label>
                                    </div> 
                                </b-col>                           
                                <b-col cols="2" class="pl-0 pr-0">
                                    <b-form-input                                           
                                        size="sm" 
                                        class="negrita" 
                                        @keyup.enter="sendItem(row.item)" 
                                        v-model="row.item.precioUnitario">
                                    </b-form-input>    
                                </b-col>
                                <b-col cols="2" class="pl-0 pr-0">
                                    <b-form-input v-if="pdv!=1"
                                        placeholder="Cantidad" 
                                        class="negrita"        
                                        size="sm" 
                                        @keyup.enter="sendItem(row.item)" 
                                        v-model="row.item.cantidad">
                                    </b-form-input>
                                    <b-form-input v-else="pdv!=2" 
                                        style="background-color:none"
                                        class="negrita"
                                        disabled  
                                        size="sm" 
                                        @keyup.enter="sendItem(row.item)" 
                                        v-model="row.item.cantidad">
                                    </b-form-input>
                                </b-col>
                                <b-col cols="1">
                                    <b-button 
                                        @click="pdv==1 ? montoItem(row.item):sendItem(row.item)" 
                                        variant="success" size="sm">
                                        <i class="fa fa-shopping-basket"></i>
                                    </b-button>  
                                </b-col>
                                </b-row>                       
                        </template>
                        <template slot="acciones" slot-scope="row">
                            <b-button  @click="reciveLista(row,row.index,row.item)" 
                                size="sm"
                                variant="light"
                                style="border:none"
                                title="observaciones"
                                >
                                <template v-if="!row.item.reciveLista">
                                    <i class="fa fa-arrow-down text-primary" aria-hidden="true"></i>
                                </template>
                                <template v-else>
                                    <i style="color:red" class="fa fa-arrow-up" aria-hidden="true"></i>
                                </template>
                            </b-button>
                        </template>
                        <template slot="row-details" slot-scope="row">
                            <b-row>
                                <b-col style="padding-left:6.6%" cols="6">
                                    <b-form-input 
                                        class="negrita input-placedark " 
                                        placeholder="Observacion del item" 
                                        size="sm" 
                                        v-model="row.item.observacion">
                                    </b-form-input>
                                </b-col>
                                <b-col cols="4">
                                    <b-select
                                        v-model="row.item.subopcionSeleccionada"
                                        class="form-control"
                                    >
                                        <!-- PLACEHOLDER -->
                                        <option value="" disabled>
                                        Seleccione complemento
                                        </option>

                                        <!-- LISTADO DESDE BACKEND -->
                                        <option
                                        v-for="(sub, i) in row.item.subopciones"
                                        :key="i"
                                        :value="sub.descripcion"
                                        >
                                        {{ sub.descripcion }}
                                        </option>
                                    </b-select>
                                </b-col>
                                <b-col cols="2">
                                    <h5 class="mt-1"><b-badge>{{ row.item.codigo }}</b-badge></h5>
                                </b-col>
                                <!-- <b-col cols="2">
                                    <h5 class="mt-1"><b-badge>{{ row.item.unidadMedida }}</b-badge></h5>  
                                </b-col> -->
                                <!-- <b-col cols="1">
                                    <template v-if="row.item.tipoAfectacionIgv == '01'">
                                        <h5 class="mt-1"><b-badge>Gravado</b-badge></h5>
                                    </template>
                                    <template v-else-if="row.item.tipoAfectacionIgv == '02'">
                                        <h5 class="mt-1"><b-badge>Inafecto</b-badge></h5>
                                    </template>
                                    <template v-else-if="row.item.tipoAfectacionIgv == '03'">
                                        <h5 class="mt-1"><b-badge>Exonerado</b-badge></h5>
                                    </template>
                                </b-col> -->
                            </b-row>
                        </template>
                        </b-table>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"	sm="4"	md="6"	lg="8"	xl="8">
                            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                        </b-col>
                        <b-col cols="12"	sm="8"	md="6"	lg="4"	xl="4">
                            <div v-if="pdv == 1">
                                <b-pagination size="sm" :total-rows="total" v-model.number="pactual" @input="listProduct" :per-page="limite"></b-pagination>
                            </div>
                            <div v-else-if="pdv == 0">
                                <b-pagination size="sm" :total-rows="total" v-model.number="pactual" @input="listProductComercio" :per-page="limite"></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <!-- Importacion de Items | item: item a importar | action : accion a realizar-->
            <import :item="item" :action="action" :igvGlobal="igvGlobal" :diez="diez" :dieciocho="dieciocho" :unoDieciocho="unoDieciocho" :unoUno="unoUno" :ceroDieciocho="ceroDieciocho" :ceroUno="ceroUno" @totalitems="totalitems" ></import>
            <!-- Fin de importacion de items -->
        </template>
        <template v-else>
            <!-- PDV tiendas -->
            <punto-venta></punto-venta>
            <!-- Fin de PDV tiendas -->
        </template>
        <b-modal size="lg" id="adicionales" title="Datos Adicionales" v-model="modaladicionales">
            <template>
                <b-row>
                    <b-col xl="5">
                        <b-form-input size="sm" v-model="key" placeholder="Nombre del adicional"></b-form-input>
                    </b-col>
                    <b-col xl="5">
                        <b-form-input size="sm" v-model="value" placeholder="Valor del adicional"></b-form-input>
                    </b-col>
                    <b-col xl="2">
                        <b-button variant="primary" size="sm" @click="addAdicional()" :disabled="validAdicional()"><i class="fa fa-plus-circle"></i> Agregar</b-button>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col>
                        <b-table small striped hover :items="adicionales" :fields="adicionales_fields">
                            <template slot="acciones" slot-scope="row">
                                <b-button variant="danger" size="sm" @click="deleteAdicional(row.index)"><i class="fa fa-trash"></i></b-button>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </template>
            <div slot="modal-footer" class="w-100">
                
            </div>
        </b-modal>
        <b-modal size="xl" id="ticket" title="Lista de Emitidos" >
            <template>
                <b-tabs class="emisiones" v-model="tabindex">
                    <b-tab title="Facturas">
                        <template v-if="tabindex == 0">
                            <tickets-market :tabindex="tabindex" :tipopdv="tipopdv"></tickets-market>
                        </template>
                    </b-tab>
                    <b-tab title="Boletas">
                        <template v-if="tabindex == 1">
                             <tickets-market :tabindex="tabindex" :tipopdv="tipopdv"></tickets-market>
                        </template>
                    </b-tab>
                    <b-tab title="Proforma">
                        <template v-if="tabindex == 2">
                             <tickets-market :tabindex="tabindex" :tipopdv="tipopdv"></tickets-market>
                        </template>
                    </b-tab>
                    <b-tab title="Guias Remisión">
                        <template v-if="tabindex == 3">
                             <tickets-market :tabindex="tabindex" :tipopdv="tipopdv"></tickets-market>
                        </template>
                    </b-tab>
                    <b-tab title="Nota de Venta">
                        <template v-if="tabindex == 4">
                             <tickets-market :tabindex="tabindex" :tipopdv="tipopdv"></tickets-market>
                        </template>
                    </b-tab>
                </b-tabs>
            </template>
            <div slot="modal-footer" class="w-100">
                
            </div>
        </b-modal>
        <b-modal size="xl" title="Ingresar Datos"  centered v-model="modalgrifo">
            <template>
                <b-row>
                    <b-col xl="8">
                      <h4> <b>Producto vendido:</b> {{nameProducto}}</h4>
                    </b-col>
                    <b-col>
                        <h4> <b>Precio Unitario:</b> {{moneda.simbolo}}{{precioUniProduc}}</h4>
                    </b-col>
                </b-row><br>
                <b-row>
                    <b-col xl="12">
                        <b-form-input style="border-color:skyblue; border-width:2px" size="lg" v-model="placaGrifo" placeholder="Placa"></b-form-input><br>
                        <b-form-input style="border-color:skyblue; border-width:2px" size="lg" @keyup.enter="agregarItemGrifo()" v-model="precioGrifo" placeholder="Importe venta"></b-form-input>
                    </b-col>
                </b-row>
            </template>
            <div slot="modal-footer" class="w-100">
                <b-button @click="agregarItemGrifo()" class="float-right" variant="primary">Agregar</b-button>
            </div>
        </b-modal>
        <b-modal size="lg" id="cargos" title="Agregar Otros Cargos" v-model="modalcargo">
            <template>
                <b-row>
                <b-col cols="12" sm="12"	md="6"	lg="6"	xl="6">
                    <select class="form-control input-placedark input-dark" v-model="otroCargo">
                    <option v-for="otrocargo in listaOtrosCargos" :value="otrocargo" :key="otrocargo.codigo">{{ otrocargo.descripcion }}</option>
                    </select>
                </b-col>
                <b-col cols="2" sm="2"	md="1"	lg="1"	xl="1"><p class="mt-2">{{ moneda.simbolo }}</p></b-col>
                <b-col cols="8" sm="8"	md="4"	lg="4"	xl="4">
                    <b-form-input
                    type="number"
                    v-model="montoOtroCargo"
                    placeholder="Monto del cargo"
                    @keyup.enter="addMontoCargo()"
                    ></b-form-input>
                </b-col>
                <b-col cols="2" sm="2"	md="1"	lg="1"	xl="1">
                    <b-button variant="success" @click="addMontoCargo()"><i class="fa fa-plus"></i></b-button>
                </b-col>
                </b-row>
                <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                    <b-table  
                        striped 
                        hover 
                        small 
                        responsive
                        outlined
                        :fields="otroscargos_fields" 
                        :items="listaOtrosCargosAgregados" 
                        :busy="otroscargosbusy">
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Cargando...</strong>
                        </div>
                        <template slot="descripcion" slot-scope="row">
                            <div v-if="row.item.codigoMotivoCargo==50">
                                Cargos globales que no afectan la base imponible del IGV/IVAP
                            </div>
                        </template>
                        <template slot="montoCargo" slot-scope="row">
                            {{ moneda.simbolo }} {{ row.item.montoCargo }}
                        </template>
                        <template slot="acciones" slot-scope="row">
                            <b-button size="sm" variant="danger" @click="deleteOtroCargo(row.index, row.item)"><i class="fa fa-trash"></i></b-button>
                        </template>
                    </b-table>
                </b-col>
                </b-row>
            </template>
            <div slot="modal-footer" class="w-100">
                <b-row>
                <b-col cols="12" sm="12"	md="8"	lg="8"	xl="8">
                    <b-button size="sm" variant="danger" @click="cerrarmodalOtroCargo()"><i class="fa fa-times"></i> Cerrar</b-button>
                </b-col>
                <b-col cols="12" sm="12"	md="4"	lg="4"	xl="4">
                    Sumatoria de cargos: {{ moneda.simbolo }} {{ totales.sumatoriaOtrosCargos }}
                </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal size="xs" v-model="modalimpresion">
            <template slot="modal-header">
                <div class="text-center">
                Telemovil.global
                </div>
            </template>
            <template>
            <plantilla v-if="pdv != 1" :impresion="dataImpresion" :printweb="printweb"></plantilla>
            <plantilla-grifo v-if="pdv == 1" :impresion="dataImpresion" :printweb="printweb"></plantilla-grifo>
            </template>
            <template slot="modal-footer">
                <b-row>
                    <b-col cols="3" class="pr-0">
                        <template v-if="selected == 1 || selected == 2">
                            <b-form-input style="border-color:black;color:black" type="number" placeholder="Num. Celular" v-model="numberwsp"  @keyup.enter="send_message()"></b-form-input>
                        </template>
                    </b-col>
                    <b-col cols="3" class="pl-0">
                         <template v-if="selected == 1 || selected == 2">
                            <b-button title="Enviar a Whatsapp" style="border-color:black" variant="success"  @click="send_message()">
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
                            </b-button>
                        </template>
                    </b-col>
                    <b-col cols="3" class="">
                        <b-button size="sm"  class="btn btn-info mr-5" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
                    </b-col>
                    <b-col cols="3" class="">
                        <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
        <b-modal v-model="errorEmisionRapida" centered size="lg">
            <div>       
                <b-row no-gutters>
                <b-col md="5" class="ml-4">
                    <b-img src="images/error3.png"  height="260%" style="width:90%" ></b-img>
                </b-col>
                <b-col md="6">
                    <b-card-body title="Ups! error">
                        <b-card-text>
                            {{error1}} <br>
                            <hr>
                            {{error2}} <br>
                            <hr>
                            {{error3}}
                        </b-card-text>
                    </b-card-body>
                </b-col>
                </b-row>
            </div>
            <template slot="modal-footer">
                <b-button variant="danger" @click="cerrarmodal()" >Cerrar</b-button>
            </template>
        </b-modal>
        <!-- a CUOTAS CREDITO -->
        <b-modal size="lg" v-model="modalCredito">
      <b-row class="mb-2">
        <b-col cols="4">
          <datepicker class="input-placedark input-dark"
            v-model="fechaPagoCuota"
            :language="es"
            :format="customFormatter"
            :bootstrap-styling="true"
            :disabledDates="diasnopermitidos"
            placeholder="Fecha de Vencimiento"
          ></datepicker>
        </b-col>
        <b-col cols="4">
          <b-input class="text-center"
            type="number"
            v-model="montoPagoCuota"
            @keyup.enter='addcuota()'
            placeholder="Monto cuota"
          ></b-input>
        </b-col>
        <b-col>
          <b-button class="mt-1" variant="primary" size="sm" :disabled="validarcredito" @click="addcuota()"><i class="fas fa-plus"></i></b-button>
        </b-col>
      </b-row>
      <template slot="modal-header">
        <h5>Cuotas Crédito</h5>
            <div style="width:30%;text-align:right">
                <h4>Total Factura:</h4>
            </div>
            <div style="float:right;width:50%">
                <h4 v-if="totales.importeTotal && totales.importeTotal !=''" style="color:red">{{ moneda.simbolo }}{{totales.importeTotal.toFixed(2)}}</h4>
            </div>
      </template>
     <b-table
     :outlined="outlined"
      small   
      :items="cuotasCredito" 
      :fields="cuotas_credito">
      <template slot="acciones" slot-scope="row">
          <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
      </template>
     </b-table>
     <template>
       <div slot="modal-footer" class="w-100">
         <b-row>
         <b-col cols="12" sm="12" md="10" lg="10" xl="10" >  
           <div style="color:">
             <h5>Total Credito : {{totalcredito}}</h5>
           </div>
         </b-col>
         <b-col cols="12" sm="12" md="2" lg="2" xl="2">
           <b-button variant="primary" @click="modalcredito()">Cerrar</b-button>
         </b-col>
       </b-row>
       </div> 
      </template>
    </b-modal>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import { Document } from '@/models/Document.js'
import { TipoMoneda } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import Totales from '@/components/comunes/Totales'
import Import from '@/components/comunes/ItemsImport'
import PuntoVenta from '@/components/factura/PuntoVenta'
import Plantilla from '@/components/comunes/PlantillaImpresion'
import PlantillaGrifo from '@/components/comunes/PlantillaGrifo'
import { FormaPagoPDV } from '@/shared/utils'
import { es } from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker";
import TicketsMarket from '@/components/comunes/TicketsMarket'
    export default {
        name: 'EmisionRapida',
        props: ['tipopdv'],
        components: {
            Datepicker,
            Totales,
            Import,
            Plantilla,
            PlantillaGrifo,
            PuntoVenta,
            TicketsMarket
        },
        data: () => {
            return {
                pdv: 1,
                tabindex:0,
                otroscargosbusy: false,
                listaOtrosCargosAgregados: [],
                otroscargos_fields: [
                    {key: 'descripcion', label: 'Descripcion', sortable: true},
                    {key: 'montoCargo', label: 'Monto', sortable: true},
                    {key: 'acciones', label: 'Acciones'}
                ],
                montoOtroCargo: '',
                otroCargo: {codigo: '50', descripcion: 'Cargos globales que no afectan la base imponible del IGV/IVAP'},
                listaOtrosCargos: [
                    {codigo: '50', descripcion: 'Cargos globales que no afectan la base imponible del IGV/IVAP'}
                ],
                adicionales: [],
                adicionales_fields: [
                    {key: 'key', label: 'Clave'},
                    {key: 'value', label: 'Valor'},
                    {key: 'acciones', label: 'Acciones'}
                ],
                key: '',
                value: '',
                modaladicionales: false,
                modalcargo: false,
                newimpresion: true,
                vistaimpresion: false,
                printweb: false,
                modalimpresion: false,
                pago: 0.00,
                vuelto: 0.00,
                listaPagos: [],
                fpago: '',
                tabIndex: 0,
                busquedaname: '',
                busquedacode: '',
                cargandoproducto: false,
                receptor: {
                    numero:'',
                    tipo:'6',
                    razonSocial:'',
                    direccion:'',
                },
                tipoMoneda: TipoMoneda,
                moneda: {
                    id: '1',
                    codigo: 'PEN',
                    descripcion: 'SOLES',
                    simbolo: 'S/.'
                },
                selected: 0,
                options: [
                    { value: 1, text:'(F) Factura' },
                    { value: 2, text: '(B) Boleta' },
                    { value: 8, text: '(P) Proforma' },
                    { value: 11, text: '(OP) OrdenPago' },
                    { value: 12, text: '(NV) NotaVenta' },
                    // { value: 3, text: '(NC) Notas de Crédito' },
                    // { value: 4, text: '(ND) Notas de Débito' },
                    // { value: 5, text: '(GR) Guias de Remision' }
                ],
                products: [],
                items: [],
                products_fields: [
                    {key: "acciones",label:""},
                    {key: 'nombrecustom', label: ''},
                ],
                items_fields: [
                    {key: 'cantidad', label: 'Cant.'},
                    {key: 'codigoProducto', label: 'Código'},
                    // {key: 'unidadMedidaCantidad', label: 'U. M.', sorteable: true},
                    {key: 'descripcion', label: 'Descripción ITEM', sorteable: true},
                    {key: 'observacion', label: 'Observación', sorteable: true},
                    {key: 'precioVentaUnitario', label: 'P. Unit.', sorteable: true},
                    {key: 'valorVentaVista', label: 'P. Total', sorteable: true},
                    {key: 'acciones', label: 'Acc.'},
                ],
                isBusy: false,
                total: 0.00,
                desde: 0.00,
                hasta: 0.00,
                pactual: 1,
                limite: 20,
                orden: 'desc',              
                seriesCargadas: false,
                rolSeries: '',
                indexSerie: 0,
                listaSeries: [],
                totales: {},
                // document: {},
                item: {},
                action: {
                    i: false,
                    reset: false
                },
                cargandoreceptor: false,
                rucValid: true,
                listarec: true,
                norec: false,
                listaReceptores: [],
                direcciones: [],
                listaCorreos: [],
                ticket: {
                    email: [],
                    tipoOperacion: '',
                    serie: '',
                    montoTotalImpuestos: 0.00,
                    totalVentaGravada: 0.00,
                    totalVentaExonerada: 0.00,
                    sumatoriaIgv: 0.00,
                    importeTotal: 0.00,
                    adicional: {
                        dirAlternativa: '',
                        tipo_igv:''
                    },
                    guiasRelacionada: [],
                    docRelacionada: [],
                    items: [],
                    receptor: {
                        tipo: '',
                        nro: '',
                        razonSocial: '',
                        direccionFiscal: ''
                    },
                    cargosDescuentosGlobales:[],
                },
                femision: '',
                fvencimiento: '',
                formaPago: FormaPagoPDV,
                formadepago: {
                    codigo: '008',
                    nombre: 'Efectivo ventas menores'
                },
                documentosIdentidad: DocumentosIdentidad,
                tipoDocumento: 0,
                tdocdisabled: false,
                emitiendo: false,
                dataImpresion: {},
                dataImpresionWsp:{},
                proforma: {
                receptor: {
                  tipo: '',
                  nro: '',
                  razonSocial: '',
                  direccionFiscal: ''
                },
                adicional: {
                    tipo_igv:''
                },
                moneda: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: ''
              },
              notaVenta: {
                receptor: {
                  tipo: '',
                  nro: '',
                  razonSocial: '',
                  direccionFiscal: ''
                },
                adicional: {
                    tipo_igv:''
                },
                moneda: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: ''
              },
                observaciones: '',
                plazoentrega: '',
                tipoPago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                mostrardni:false,
                norecdni:false,
                listadni:[],
                errorEmisionRapida:false,
                error1:'',
                error2:'',
                error3:'',
                fechaPagoCuota:'',
                montoPagoCuota:'',
                cuotasCredito:[],
                cuotas_credito:[
                    {key:'identificadorCuota',label:'Cuotas'},
                    {key:'fechaPagoCuota', label:'Fecha Vencimiento'},
                    {key:'montoPagoCuota', label:'Monto',},      
                    {key:'acciones', label:'Agregar'}
                ],
                totalcredito:0.0,
                modalCredito:false,
                validarcredito:true,
                outlined:true,
                es: es,
                filtroItems:[],
                filtroItemsComercio:[],
                listaTag:[],
                listaCategoria:[],
                catProducto:'',
                ordenpago: {
                    receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccionFiscal: ''
                    },
                    adicional: {
                        tipo_igv:''
                    },
                    moneda: '',
                    plazoentrega: '',
                    formapago: '',
                    garantia: '',
                    telefono: '',
                    atencion: '',
                    observaciones: '',
                    tag3:'',
                sistema:'facturaonline'
                },
                tag3:'',
                sistema:'facturaonline',
                idMovil: '',
                modalgrifo:false,
                nameProducto:'',
                precioUniProduc:'',
                placaGrifo:'',
                precioGrifo:'',
                dataGrifo:'',
                diasnopermitidos: {
                    ranges: []
                    },
                igvGlobal:null,
                unoDieciocho:1.18,
                ceroDieciocho:0.18,
                dieciocho:18,
                // unoUno:1.1,
                // ceroUno:0.1,
                // diez:10,
                unoUno:1.105,
                ceroUno:0.105,
                diez:10.5,
                monederoPago:'',
                colorPago1:false,
                colorPago2:false,
                colorPago3:false,
                colorPago4:false,
                colorPago5:false,
                colorPago6:false,
                colorPago7:false,
                colorPago8:false,
                numberwsp:'',
                selectedRetencion: null,
                optionsIgv: [
                    { value: null, text: 'Afecto a Retención' },
                    { value: 1, text: '3%' },
                ],
                cargosDescuentosGlobales:[],
                retencionesOn:false
            }
        },
        mounted(){
            this.initDocument(),
            this.getSeries(),
            this.listProduct(),
            this.listProductComercio(),
            this.getCategoria();
            this.listTag();
            this.initDate();
        },
        watch:{
            tipopdv: function () {
                this.pdv = this.tipopdv
            },
            modalimpresion: function () {
                if(this.modalimpresion == false){
                    this.printweb = false
                }
            },
            cadenabusqueda: function () {
                if(this.cadenabusqueda.length==0){
                    this.listProduct()
                    this.listProductComercio()
                }
            },
            selected: function () {
                this.getSeries()
                this.initReceptor()
                if(this.selected==1){
                    this.tipoDocumento = '6'
                    this.tdocdisabled = true
                }else if(this.selected==2){
                    this.tipoDocumento = '0'
                    this.tdocdisabled = false
                }else if(this.selected==8){
                    this.tipoDocumento = '6'
                }else if(this.selected==11){
                     this.tipoDocumento = '0'
                }
            },
            'receptor.numero': function () {
                if(this.receptor.numero==''){
                    this.initReceptor()
                }
            },
            'receptor.razonSocial': function () {
                if(this.receptor.razonSocial==''){
                    this.initReceptor()
                }
            },
            busquedacode: function () {
                if(this.busquedacode.length > 0){
                    this.busquedaname = ''
                }
            },
            busquedaname: function () {
                if(this.busquedaname.length > 0){
                    this.busquedacode = ''
                }
            },
            formadepago(){
                if(this.formadepago.codigo == '00'){
                this.modalCredito = true;
            }   
            },
            montoPagoCuota(){
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                    this.validarcredito = false
                }else{
                    this.validarcredito = true
                }
            },
            fechaPagoCuota(){
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                    this.validarcredito = false
                }else{
                    this.validarcredito = true
                }
            },
            catProducto(){
                this.catProducto
                this.searchProductCateg()
            },
            tag3(){
                this.idMovil = this.tag3.idTag
            },
            selectedRetencion(){
                if(this.selectedRetencion != null){
                    this.retencionIgv();
                }
            },
        },
        methods: {
            customFormatter: function(date) {
                return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
            },
            montoItem: function (data) {            
                if(this.pdv==1 ){
                    this.modalgrifo = true;
                    this.nameProducto = data.descripcion
                    this.precioUniProduc = data.precioUnitario  
                    this.dataGrifo = data
                }
                // if(this.pdv==1){
                //     this.$swal(
                //         {dangerMode: false, buttons: true, title: 'Ingrese monto', text: 'Producto vendido: '+data.descripcion + ' ' + ' ' +'Precio Unitario:' + this.moneda.simbolo+data.precioUnitario, content: "input"}                     
                //     )
                //     this.$swal(
                //         {dangerMode: false, buttons: true, title: 'Ingrese monto', text: 'Producto vendido: '+data.descripcion + ' ' + ' ' +'Precio Unitario:' + this.moneda.simbolo+data.precioUnitario, content: "input"}                     
                //     )
                //     .then((value) => {
                //         console.log(value)
                //         if(value){
                //             this.addItemGrifo(data, value)
                //         }else{

                //         }
                //     });
                // }else{
                //     this.$snotify.warning('La placa es obligatoria, asegurese que tenga minimo 4 y maximo 10 caracteres','Atención')
                // }
                
            },
            agregarItemGrifo(){
                if(this.pdv==1 && this.placaGrifo.length>3 && this.placaGrifo.length<11  && this.precioGrifo !=''){
                    this.addItemGrifo(this.dataGrifo,this.precioGrifo,this.placaGrifo)
                }else if(this.placaGrifo == '' || this.placaGrifo.length< 4 || this.placaGrifo.length > 10 ){
                   this.$snotify.warning('La placa es obligatoria, asegurese que tenga minimo 4 y maximo 10 caracteres','Atención') 
                }
                else if(this.precioGrifo == ''){
                   this.$snotify.warning('Debe ingresar un precio','Atención') 
                }
            },
            addItemGrifo: function (data,monto,placa) {
                // Tengo la data del item y el monto
                let cantidad = monto / data.precioUnitario
                let item = data
                item.cantidad = parseFloat(cantidad.toFixed(4))
                item.valorVenta = (cantidad*parseFloat(item.precioUnitario)).toFixed(4)
                item.placa = placa
                this.item = item
                this.action.i = true
                if(this.items.length>0){
                    this.action.reset = false
                }
                this.modalgrifo = false;
                this.precioGrifo = '';
                this.placaGrifo = '';
            },
            deleteOtroCargo: function (index, value) {
                this.$swal({
                    title: 'Eliminar Otro Cargo',
                    text: 'Seguro de eliminar el cargo con monto '+value.montoCargo,
                    icon: 'error',
                    buttons: true,
                    dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                    this.listaOtrosCargosAgregados.splice(index,1)
                    }
                })
            },
            cerrarmodalOtroCargo: function () {
                this.modalcargo = false
            },
            addMontoCargo: function () {
                let otrocargo = {
                    codigoMotivoCargo: this.otroCargo.codigo,
                    factorNumericoCargo: parseFloat((this.montoOtroCargo*100)/this.totales.importeTotal),
                    montoCargo: parseFloat(this.montoOtroCargo),
                    montoBaseCargo: this.totales.baseCargo
                }
                if(this.montoOtroCargo > 0){
                    this.listaOtrosCargosAgregados.push(otrocargo)
                    this.montoOtroCargo = ''
                }else{
                    this.$snotify.warning('El monto debe ser mayor a 0','Cuidado')
                }
            },
            deleteAdicional: function (index) {
                this.adicionales.splice(index,1)
                this.key = ''
                this.value = ''
            },
            validAdicional: function () {
                if(this.key != '' && this.value != ''){
                    return false
                }else{
                    return true
                }
            },
            addAdicional: function () {
                let adicional = {}
                adicional.key = this.key
                adicional.value = this.value
                this.adicionales.push(adicional)
                this.key = ''
                this.value = ''
            },  
            nuevaImpresion: function () {
                this.modalimpresion = false,
                this.vistaimpresion = false,
                this.newimpresion = true,
                this.initTicket()
            },
            print: function () {
                this.printweb = true
            },
            openModal: function ()  {
                this.modalimpresion = true
            },
            removePago: function (index) {
                this.listaPagos.splice(index,1)
                if(this.listaPagos.length == 0){
                    this.cargosDescuentosGlobales = []
                    this.selectedRetencion = null
                }
            },
            addPago: function () {
                let pago = {
                    descripcion: '',
                    monto: 0.00
                }
                if(this.fpago != '' && this.formadepago.codigo != '000'){
                    pago.descripcion = this.formadepago.nombre
                    pago.monto = this.fpago
                    if(this.validatePago()){
                        this.listaPagos.push(pago)
                        this.fpago = ''
                        pago = {}
                        this.accumulatePagos()
                    }
                }else{
                    this.$snotify.warning("Elegir una forma de pago y agregar un monto","Atencion")
                }
            },
            validatePago: function () {
                if( parseFloat(this.fpago) > 0 ){
                    return true
                }else{
                    this.$snotify.warning('El pago debe ser mayor a cero!', 'Cuidado')
                    return false
                }
            },
            accumulatePagos: function () {
                let sumapagos = 0.00
                this.listaPagos.forEach(function (element){
                    sumapagos += parseFloat(element.monto)
                })
                this.pago = sumapagos
                this.pago>=this.totales.importeTotal && this.totales.importeTotal>0 ? this.vuelto = this.pago - this.totales.importeTotal: this.vuelto = 0.00
                return this.pago.toFixed(2)
            },
            validTicket: function () {
                let serie = ''
                let pago = false
                let totalpagado = Math.round(parseFloat(this.pago)*100)/100
                let importe = Math.round(parseFloat(this.totales.importeTotal)*100)/100
                totalpagado>=importe ? pago = true: pago = false
                this.indexSerie==0 ? serie = this.listaSeries[0]: serie = this.listaSeries[this.indexSerie]
                switch(this.selected){
                    case 1: 
                        if(this.receptor.numero != '' && this.receptor.razonSocial != '' && this.items.length > 0 && serie != '' && pago && this.newimpresion){
                            return false
                        }else{
                            return true
                        }
                        break;
                    case 2:
                        if(this.items.length > 0 && serie != '' && pago && this.newimpresion){
                            return false
                        }else{
                            return true
                        }
                        break;
                    case 12:
                        if(this.items.length > 0 && serie != '' && pago && this.newimpresion){
                            return false
                        }else{
                            return true
                        }
                        break;
                }
            },
            validarImporteTotal: function () {
                if(this.selected == 1){
                    this.sendTicket()
                }else{
                    if(this.totales.importeTotal >= 700 && this.tipoDocumento == '0'){
                        this.$swal({
                        title: 'Atención!!!',
                        text: 'El importe total supera los 700 Soles, debe ingresa número de documento.',
                        icon: 'warning',
                        buttons: true,
                        dangerMode: true
                        }).then((willDelete) => {
                            
                        })
                    }else{
                        this.sendTicket()
                    }
                }
            },
            pitcherReceiver: function () {
                if(this.receptor.razonSocial.length >= 3 ){
                    setTimeout(() => this.getReceiversByRSocial(), 200);
                }else if(this.receptor.razonSocial.length <= 2){
                    // this.initReceptor()
                }  
            },  
            initReceptor: function () {
                this.receptor = {
                    numero:'',
                    tipo:'6',
                    direccion:'',
                    nombre:'',
                    direccionReferencia: '',
                    razonSocial:''
                },
                this.listaReceptores = [],
                this.cargandoreceptor = false
            },
            getReceiversByRSocial: function () {
                if(this.receptor.razonSocial.length>=3 && this.tipoDocumento){
                    this.cargandoreceptor = true
                    this.listarec = true
                    this.norec = false
                axios
                .post(process.env.VUE_APP_API_URL + 'receptores/lista/razonsocial',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.razonSocial,
                })
                .then(response => (
                    this.listaReceptores = response.data.response,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                ))
                .catch(function (error){
                    this.cargandoreceptor = false
                })
                }else{
                this.listaReceptores = [],
                this.cargandoreceptor = false
                }
            },
            sendTicket: function () {
                this.emitiendo = true
                let ruta = ''
                this.ticket.token = this.$store.getters.userToken
                if(this.selected==1){
                    this.ticket.receptor.nro = this.receptor.numero.toString()
                    this.ticket.receptor.tipo = '6'
                    this.ticket.receptor.razonSocial = this.receptor.razonSocial
                    this.ticket.receptor.direccionFiscal = this.receptor.direccion
                    this.ticket.adicional.dirAlternativa = this.receptor.direccion
                }else{
                    if(this.tipoDocumento==0){
                        this.ticket.receptor.nro = '-'
                        this.ticket.receptor.tipo = '0'
                        this.ticket.adicional.otroNombre = this.receptor.razonSocial
                        this.ticket.adicional.dirAlternativa = this.receptor.direccion
                    }else{
                        this.ticket.receptor.nro = this.receptor.numero
                        this.ticket.receptor.tipo = this.receptor.tipo
                        this.ticket.receptor.razonSocial = this.receptor.razonSocial
                        this.ticket.receptor.direccionFiscal = this.receptor.direccion
                        this.ticket.adicional.otroNombre = this.receptor.razonSocial
                        this.ticket.adicional.dirAlternativa = this.receptor.direccion
                    }
                } 
                if(this.indexSerie == 0){
                    this.ticket.serie = this.listaSeries[0]
                }else{
                    this.ticket.serie = this.listaSeries[this.indexSerie]
                }
                this.ticket.adicional.username = this.$store.getters.userData.username;
                this.ticket.montoTotalImpuestos = this.totales.montoTotalImpuestos
                this.ticket.totalVentaGratuita = this.totales.totalVentaGratuita
                this.ticket.sumatoriaIgvGratuitas = this.totales.sumatoriaIgvGratuitas
                this.ticket.totalVentaGravada = this.totales.totalVentaGravada
                this.ticket.sumatoriaIgv = this.totales.sumatoriaIgv
                this.ticket.totalVentaExonerada = this.totales.totalVentaExonerada
                this.ticket.totalVentaInafecta = this.totales.totalVentaInafecta
                this.ticket.totalVentaExportacion = this.totales.totalVentaExportacion
                if(this.totales.importeTotal && this.totales.importeTotal !=''){
                    this.ticket.importeTotal = parseFloat(this.totales.importeTotal.toFixed(2))
                }
                if(this.totales.totalVentaExonerada > 0){
                    this.ticket.totalVentaExonerada = this.totales.totalVentaExonerada
                }
                if(this.totales.totalVentaInafecta > 0){
                    this.ticket.totalVentaInafecta = this.totales.totalVentaInafecta
                }
                if(this.totales.totalVentaExportacion > 0){
                    this.ticket.totalVentaExportacion = this.totales.totalVentaExportacion
                }
                    this.ticket.tipoOperacion = '0101'
                if(this.femision != ''){
                    this.ticket.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                }
                if(this.fvencimiento != ''){
                    this.ticket.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
                }
                if(this.formadepago.codigo != '000'){
                if(this.formadepago.codigo === '00'){
                    this.ticket.adicional.credito = this.cuotasCredito
                    this.ticket.adicional.montoPendientePagoCredito = this.totalcredito
                    this.ticket.adicional.nombreFormaPago = this.formadepago.nombre
                }else{
                    this.ticket.adicional.formaPago = this.formadepago.codigo
                    this.ticket.adicional.nombreFormaPago = this.formadepago.nombre
                }
                }
                if(this.monederoPago == 1){
                this.ticket.monedero = 1
                this.ticket.nombreMonedero = "Yape"
                }else if(this.monederoPago == 2){
                this.ticket.monedero = 2
                this.ticket.nombreMonedero = "Plin"
                }else if(this.monederoPago == 3){
                this.ticket.monedero = 3
                this.ticket.nombreMonedero = "A Crédito"
                }else if(this.monederoPago == 4){
                this.ticket.monedero = 4
                this.ticket.nombreMonedero = "Tarjeta de Débito"
                }else if(this.monederoPago == 5){
                this.ticket.monedero = 5
                this.ticket.nombreMonedero = "Efectivo ventas menores  "
                }else if(this.monederoPago == 6){
                this.ticket.monedero = 6
                this.ticket.nombreMonedero = "Tarjeta de Crédito emitida en Perú"
                }else if(this.monederoPago == 7){
                this.ticket.monedero = 7
                this.ticket.nombreMonedero = "Depósito en cuenta"
                }else if(this.monederoPago == 8){
                this.ticket.monedero = 8
                this.ticket.nombreMonedero = "Transferencia de Fondos"
                }
                this.ticket.items = this.items,
                this.ticket.adicional.tipo_igv = this.igvGlobal
                this.ticket.email = this.listaCorreos,
                this.ticket.tipoMoneda = this.moneda.codigo
                if(this.anticipo){
                this.ticket.anticipo = true
                }
                if (Object.values(this.ticket.adicional).length == 0){
                delete this.ticket.adicional
                }
                if(this.adicionales.length>0){
                    this.ticket.adicional.extras = this.adicionales
                }
                if(this.totales.sumatoriaOtrosCargos > 0){
                    this.ticket.adicional.cargosGlobal = this.listaOtrosCargosAgregados
                    this.ticket.sumatoriaOtrosCargos = this.totales.sumatoriaOtrosCargos
                }
                if(this.cargosDescuentosGlobales !=[]){
                    this.ticket.cargosDescuentosGlobales = this.cargosDescuentosGlobales;
                }else{
                    delete this.ticket.cargosDescuentosGlobales
                }
                 this.selected==1 ? ruta = 'facturas/emitir': ruta = 'boletas/emitir'
                axios
                .post(process.env.VUE_APP_API_URL + ruta, this.ticket)
                .then(response => (
                    this.numberwsp = '',
                    this.emitiendo = false,
                    this.$snotify.success(response.data.msg, 'Exito'),
                    this.dataImpresion = response.data.response,
                    this.dataImpresionWsp = response.data.response,
                    this.dataImpresion.pago = this.pago,
                    this.dataImpresion.vuelto = this.vuelto,
                    this.dataImpresion.razonSocial = this.receptor.razonSocial,
                    this.dataImpresion.direccion = this.receptor.direccion,
                    this.dataImpresion.tiporeceptor = this.receptor.tipo,
                    this.dataImpresion.adicionales = this.adicionales,
                    this.dataImpresion.pagos = this.listaPagos,
                    this.modalimpresion = true,
                    this.vistaimpresion = true,
                    this.newimpresion = false,
                    this.action.reset = true,
                    this.totalcredito = 0.0,
                    this.cuotasCredito = [],
                    this.selectedRetencion = null,
                    this.cargosDescuentosGlobales = []
                    // this.initTicket()          
                ))
                .catch(error => (
                    this.emitiendo = false,
                    this.$snotify.error(error.response.data.msg,'Error'),
                    this.catchError(error.response.data)
                    
                ))
            },
            catchError(value){
                this.errorEmisionRapida = true
                this.error1 = value.msg
                this.error2 = value.response.message
                this.error3 = value.response.description
            },
            cerrarmodal(){
                this.errorEmisionRapida = false
            },
            proformasave(){
                if(this.loadProforma()){
                axios
                .post(process.env.VUE_APP_API_URL + 'proformas/insertar',{
                    token: this.$store.getters.userToken,
                    serie: this.listaSeries[this.indexSerie],
                    proforma: this.proforma
                })
                .then(response => (
                    this.$snotify.success(response.data.msg,'Exito'),
                    this.dataImpresion = response.data.response,
                    this.dataImpresion.proforma.receptor.razonSocial = this.receptor.razonSocial,
                    this.dataImpresion.proforma.receptor.direccionFiscal = this.receptor.direccion,
                    this.dataImpresion.proforma.receptor.tipo = this.receptor.tipo,
                    this.dataImpresion.adicionales = this.adicionales,
                    this.dataImpresion.pagos = this.listaPagos,
                    this.modalimpresion = true,
                    this.vistaimpresion = true,
                    this.newimpresion = false,
                    this.action.reset = true
                    //this.initProforma()
                    
                ))
                .catch(error => {
                 this.$snotify.error(error.response.data.msg,'Error')
                })
                }
            },
            loadProforma: function () {
            this.proforma.receptor.tipo = this.tipoDocumento
            this.proforma.receptor.nro = this.receptor.numero
            this.proforma.receptor.razonSocial = this.receptor.razonSocial
            this.proforma.receptor.direccionFiscal = this.receptor.direccion
            this.proforma.moneda = this.moneda
            this.proforma.plazoentrega = this.plazoentrega
            this.proforma.formapago = this.tipoPago
            this.proforma.garantia = this.garantia
            this.proforma.telefono = this.telefono
            this.proforma.items = this.items
            this.proforma.totales = this.totales
            this.proforma.atencion = this.atencion
            this.proforma.observaciones = this.observaciones
            this.proforma.adicional.username = this.$store.getters.userData.username
            this.proforma.adicional.codigoComprobante = '08'
            this.proforma.adicional.tipo_igv = this.igvGlobal
            return true
            },
            initProforma: function () {
            this.plazoentrega =''
            this.tipoPago = ''
            this.garantia = ''
            this.telefono = ''
            this.atencion = ''
            this.totales = {}
            this.receptor.numero = ''
            this.receptor.direccion = ''
            this.receptor.razonSocial = ''
            this.receptor.tipo ='6'
            this.items = []
            this.listProduct()
            this.listProductComercio()
            },
            sendNotaVenta(){
                let itemBlank = []
                if(this.loadNotaVenta()){
                    axios
                    .post(process.env.VUE_APP_API_URL + 'notaventa/insertar', {
                        token: this.$store.getters.userToken,
                        serie: this.listaSeries[this.indexSerie],
                        notaVenta: this.notaVenta
                    })
                    .then(response => (
                        this.$snotify.success(response.data.msg,'Exito'),
                        this.dataImpresion = response.data.response,
                        this.dataImpresion.notaVenta.receptor.razonSocial = this.receptor.razonSocial,
                        this.dataImpresion.notaVenta.receptor.direccionFiscal = this.receptor.direccion,
                        this.dataImpresion.notaVenta.receptor.tipo = this.receptor.tipo,
                        this.dataImpresion.adicionales = this.adicionales,
                        this.dataImpresion.vuelto = this.vuelto,
                        this.dataImpresion.pagos = this.listaPagos,
                        this.dataImpresion.pago = this.pago,
                        this.modalimpresion = true,
                        this.vistaimpresion = true,
                        this.newimpresion = false,
                        this.action.reset = true
                    ))
                    .catch(error => {
                        this.$snotify.error(error.response.data.msg,'Error')
                    })
                }
            },
            loadNotaVenta: function () {
            this.notaVenta.receptor.tipo = this.tipoDocumento
            this.notaVenta.receptor.nro = this.receptor.numero
            this.notaVenta.receptor.razonSocial = this.receptor.razonSocial
            this.notaVenta.receptor.direccionFiscal = this.receptor.direccion
            this.notaVenta.moneda = this.moneda
            this.notaVenta.plazoentrega = this.plazoentrega
            this.notaVenta.formapago = this.tipoPago
            this.notaVenta.garantia = this.garantia
            this.notaVenta.telefono = this.telefono
            this.notaVenta.items = this.items
            this.notaVenta.totales = this.totales
            this.notaVenta.atencion = this.atencion
            this.notaVenta.observaciones = this.observaciones
            this.notaVenta.adicional.username = this.$store.getters.userData.username
            this.notaVenta.adicional.tipo_igv = this.igvGlobal
            this.notaVenta.adicional.codigoComprobante = '12'
            if(this.formadepago.codigo != '000'){
                if(this.formadepago.codigo === '00'){
                    this.notaVenta.adicional.credito = this.cuotasCredito
                    this.notaVenta.adicional.montoPendientePagoCredito = this.totalcredito
                    this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }else{
                    this.notaVenta.adicional.formaPago = this.formadepago.codigo
                    this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }
            }
            return true
            },
            validarRuc(){
            if(this.tipoDocumento=='0' && this.items.length > 0){
                return false
            }else{
                if(this.receptor.numero != '' && this.receptor.razonSocial != '' && this.items.length > 0){
                    return false
                }else{
                    return true
                }
            }
            },
            initTicket: function () {
                // this.action.reset = true
                this.cargosDescuentosGlobales = []
                this.plazoentrega =''
                this.tipoPago = ''
                this.garantia = ''
                this.telefono = ''
                this.atencion = ''
              
                this.item = {}
                this.receptor.numero = ''
                this.receptor.direccion = ''
                this.receptor.razonSocial = ''
                this.receptor.tipo ='6'
                this.fvencimiento = ''
                this.items = []
                this.invoice = {
                    tipoOperacion: '',
                    serie: '',
                    montoTotalImpuestos: 0.00,
                    totalVentaGravada: 0.00,
                    totalVentaExonerada: 0.00,
                    sumatoriaIgv: 0.00,
                    importeTotal: 0.00,
                    adicional: {
                        dirAlternativa: ''
                    },
                    items: [],
                    receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccion: ''
                    }
                },
                this.totales = {}
                this.selected = 2
                this.listaPagos = []
                this.listaOtrosCargosAgregados = []
                this.adicionales = []
                this.tipoDocumento = 0
                this.dataImpresion = {}
                this.formadepago = {
                    codigo: '008',
                    nombre: 'Efectivo ventas menores'
                }
                this.cuotasCredito=[]
                this.listProduct()
                this.listProductComercio(),
                this.colorPago1=false,
                this.colorPago2=false,
                this.colorPago3=false,
                this.colorPago4=false,
                this.colorPago5=false,
                this.colorPago6=false,
                this.colorPago7=false,
                this.colorPago8=false
            },
            setReceiver: function (item) {
                this.receptor.numero = item.idReceptor,
                this.receptor.tipo = item.tipo,
                this.receptor.razonSocial = item.razonSocial,
                this.receptor.direccion = item.direccionReferencia,
                this.direcciones = item.direcciones,
                this.listaCorreos = item.email,
                this.listarec = false
                if(item.tipo =="1"){
                    this.tipoDocumento = 1
                }else if(item.tipo =="6"){
                    this.tipoDocumento = 6
                }
                this.listaReceptores = []
            },
            getReceivers: function () {
                this.cargandoreceptor = true
                this.selected==1 ? this.receptor.tipo = '6': this.receptor.tipo = '0'
                if(this.receptor.numero.length >= 3){
                this.stateReceptorRuc(this.receptor.numero)
                if((this.rucValid && this.selected==1) || (this.selected==2) || (this.selected==8) ||  (this.selected==12)){
                this.listarec = true
                this.norec = false
                // lista/razonSocial
                    axios
                    .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                    token: this.$store.getters.userToken,
                    q: this.receptor.numero,
                    tipoRec: this.tipoDocumento
                    })
                    .then(response => (
                    this.listaReceptores = response.data,
                    this.cargandoreceptor = false,
                    this.receivercount(this.listaReceptores.length)
                    ))
                    .catch(error => (
                    this.listaReceptores = [],
                    this.cargandoreceptor = false,
                    this.listarec = false
                    // this.norec = false
                    ))
                }  
                }else if(this.receptor.numero.length === 0){
                this.listaReceptores = [],
                this.cargandoreceptor = false
                }else{
                this.listaReceptores = []
                }    
            },
            receivercount: function (value){
                if(!value)
                {
                    // this.$snotify.warning('No se encontró al receptor', 'Atención')
                    this.searchDNI();
                }
            },
            searchDNI(){
                this.cargandoreceptor = true             
                this.norecdni = false
                axios
                .get(process.env.VUE_APP_API_URL +'v2/dni',{
                    params:{
                        token: this.$store.getters.userToken,
                        dni: this.receptor.numero
                    }
                })
                .then(response => (
                        this.listadni = response.data,
                        this.cargandoreceptor = false,
                        this.receivedni(this.listadni),
                        this.mostrardni = true
                ))
                .catch(error => (
                    this.cargandoreceptor = false
                ))    
            },
            receivedni: function (value){
                if(!value)
                {
                    this.mostrardni = false
                    this.norecdni = true
                }
                else
                {
                    this.mostrardni = true
                    this.norecdni = false
                }
            },
            setReceiverdni(item){
                this.receptor.razonSocial = item.nombre
                this.mostrardni = false
                this.listarec = false
                this.listaReceptores = []
            },
            stateReceptorRuc (value) {
                let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
                if(this.selected == 1){
                    if(value.length == 0){
                        this.rucValid = false
                    } else if (expreg.test(value)) {
                        this.$snotify.error('RUC Inválido','Error');
                        this.rucValid = false
                    } else {        
                        this.rucValid = true       
                    }   
                }
            },
            totalitems: function (value) {
                this.items = value,
                this.action.i = false
            },
            initDocument: function () {
                this.selected = 2
                this.dataImpresion = {}
                this.pdv = this.tipopdv
            },
            searchProduct: function (parametro) {
                let busqueda = ''
                parametro=='code' ? busqueda = this.busquedacode: busqueda = this.busquedaname 
                this.cargandoproducto = true
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                    filtro: parametro,
                    p: busqueda
                    // 'name, code, codesunat, codegs1'
                    // Parametro ej: Shoes -> sho
                })
                .then(response => (
                    this.cargandoproducto = false,
                    this.products = response.data.response,
                    this.cadenabusqueda = '',
                    this.products.forEach(function(element) {
                        element.cantidad = ''
                    })
                ))
                .catch(error => (
                    this.cargandoproducto = false
                ))
            },
            searchProductCateg: function () {
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                    filtro: 'category',
                    p: this.catProducto
                    // 'name, code, codesunat, codegs1'
                    // Parametro ej: Shoes -> sho
                })
                .then(response => (
                    this.cargandoproducto = false,
                    this.products = response.data.response,
                    // this.total = response.data.producto.total,
                    // this.desde = response.data.producto.from,
                    // this.hasta = response.data.producto.to,
                    this.cadenabusqueda = '',
                    // this.isBusy = false,
                    this.products.forEach(function(element) {
                        element.cantidad = ''
                    })
                ))
                .catch(error => (
                    this.cargandoproducto = false
                    // this.cargandoproducto = false,
                    // this.$snotify.error(error.response.data.response.message, 'Error')
                ))
            },
            deleteItem: function (index) {
                this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    if(willDelete){
                        this.items.splice(index,1)
                    }
                })
            },
            insertTotal: function (value) {
                this.totales = value  
                    this.totales = value
                this.totales = value  
            },
            getSeries: function () {
                this.seriesCargadas = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.selected, {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.listaSeries = response.data.data,
                    this.rolSeries = response.data.rol,
                    this.seriesCargadas = false,
                    this.igvGlobal = response.data.igv
                ))
                .catch(error => {
                    this.seriesCargadas = false
                })
            },
            sendItem: function (data) {
                console.log(data)
                let item = data
                let cantidad = data.cantidad
                if(this.validateCantidad(data) && this.validatePrecio(data)){
                    // Insertar item con cantidad por defecto 1
                    if(cantidad == ''){
                        item.cantidad = 1
                        item.valorVenta = parseFloat(item.precioUnitario).toFixed(4)
                        this.item = item
                        this.action.i = true
                    }else{
                    // Insertar item con cantidad enviada por usuario 
                        item.valorVenta = (parseFloat(cantidad)*parseFloat(item.precioUnitario)).toFixed(4)
                        this.item = item
                        this.action.i = true
                    }
                }
                if(this.items.length>0){
                    this.action.reset = false
                }
            },
            validateCantidad: function (data) {
                if(parseFloat(data.cantidad) > 0 || data.cantidad == ''){
                    return true
                }else{
                    this.$snotify.warning('La cantidad debe ser mayor a cero','Cuidado')
                    return false
                }
            },
            validatePrecio: function (data) {
                if(parseFloat(data.precioUnitario) > 0){
                    return true
                }else{
                    this.$snotify.warning('El precio debe ser mayor a cero','Cuidado')
                    return false
                }
            },
            setPrecioVentaUnitario: function () {
                if(this.precioVentaUnitario < 0){
                  this.checkprecioventaunitario = true
                  this.responsecheckprecioventaunitario = 'Cantidad debe ser mayor a 0'
                }else{
                  this.checkprecioventaunitario = false
                  this.responsecheckprecioventaunitario = ''
                }
                if(this.especificacionIgv=='01' && this.tipoOperacion != '0200'){
                  if(!this.vunitario){
                    this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                  }
                }
                else if(this.especificacionIgv=='02' || this.especificacionIgv=='03' || this.tipoOperacion == '0200'){
                  this.valorUnitario = this.precioVentaUnitario
                }
            }, 
            listProduct: function () {
                this.isBusy = true
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/listar',{
                    token: this.$store.getters.userToken,
                    mostrarItemEn:1,
                    page: this.pactual,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response => (
                        this.filtroItems = response.data.producto.data,
                        this.total = response.data.producto.total,
                        this.desde = response.data.producto.from,
                        this.hasta = response.data.producto.to,
                        this.isBusy = false,
                        this.complementos(this.filtroItems)
                ))
                .catch(function (error){
                    this.$snotify.error(error.response.data.response.message, 'Error')
                    this.isBusy = false
                })
            },
            listProductComercio: function () {
                this.isBusy = true
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/listar',{
                    token: this.$store.getters.userToken,
                    page: this.pactual,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response => (
                        this.filtroItemsComercio = response.data.producto.data,
                        this.total = response.data.producto.total,
                        this.desde = response.data.producto.from,
                        this.hasta = response.data.producto.to,
                        this.isBusy = false,
                        this.complementos(this.filtroItemsComercio)
                ))
                .catch(function (error){
                    this.$snotify.error(error.response.data.response.message, 'Error')
                    this.isBusy = false
                })
            },
            complementos: function (data) {
                data.forEach(item => {
                    this.$set(item, 'subopcionSeleccionada', '')
                })
                if(this.pdv==0){
                    this.products = this.filtroItemsComercio;
                    data.forEach(function(element) {
                        element.cantidad = ''
                    })
                }else if(this.pdv==1){
                    // let resultadoFiltro = this.filtroItems.filter(filtro => filtro.mostrarItemEn == 1 || filtro.mostrarItemEn == 0)
                    this.products = this.filtroItems;
                    data.forEach(function(element) {
                        element.placa = ''
                    })
                }
            },
            closeList(){
            this.listarec = false;
            },
            addcuota(index,value){
                let sumatotales = 0
                sumatotales = parseFloat(this.totalcredito) + parseFloat(this.montoPagoCuota)
                if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                if(this.totales.importeTotal.toFixed(2) >= this.montoPagoCuota ){
                    if(this.totales.importeTotal.toFixed(2) >= sumatotales){
                    let total = 0.0
                    let cuota = {
                    identificadorCuota:'',
                    fechaPagoCuota:'',
                    montoPagoCuota:'',
                    } 
                    cuota.identificadorCuota = this.numerador(this.cuotasCredito.length+1)
                    cuota.fechaPagoCuota = this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD"),
                    cuota.montoPagoCuota = this.montoPagoCuota;
                    this.cuotasCredito.push(cuota)

                    this.cuotasCredito.forEach(function(element){
                    total += parseFloat(element.montoPagoCuota);
                    }) 
                    this.totalcredito = total
                    this.fechaPagoCuota = '',
                    this.montoPagoCuota = ''
                    }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                    }  
                }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                }
                }
            },
            modalcredito(){
                this.modalCredito = false
            },
            initDate(){ 
                 let r1 = {
              from: this.$moment().subtract(50000, "years"),
              to: this.$moment().subtract(0, "days")
              };
              let r2 = {
              from: this.$moment().add(5000, "years"),
              to: this.$moment().add(60000, "years")
              };
              this.diasnopermitidos.ranges.splice(r1);
              this.diasnopermitidos.ranges.splice(r2);
              this.diasnopermitidos.ranges.push(r1);
              this.diasnopermitidos.ranges.push(r2);
              this.currentdate = this.$moment().format("YYYY-MM-DD HH:mm:ss");
            },
            deletecuota(index){ 
                let totalarray =''
                totalarray = this.cuotasCredito.length+1
                this.renameident(index)
                this.cuotasCredito.splice(index, 1);

                let total = 0.0
                this.cuotasCredito.forEach(function(element){
                total += parseFloat(element.montoPagoCuota);
                }) 
                this.totalcredito = total
            },
            renameident(index){ 
                for (let i=0;i < this.cuotasCredito.length; i++) {
                    if(i > index){
                    this.cuotasCredito[i].identificadorCuota = this.numerador(i)
                    }
                }
            },
            numerador(value){
            let cuotanom = value
            let cadenacuota = ''
            if(cuotanom >=1 && cuotanom <=9){
                    cadenacuota = 'Cuota00'+ String(cuotanom)
                }else if(cuotanom >=10 && cuotanom <=99){
                    cadenacuota = 'Cuota0'+ String(cuotanom)
                }else if(cuotanom >=100 && cuotanom <=999){
                    cadenacuota = 'Cuota'+ String(cuotanom)
                }
                return cadenacuota;
            },
            vercreditos(){
                this.modalCredito = true
            },
            getCategoria(){
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/categoria/listar',{
                    token: this.$store.getters.userToken,
                })
                .then(response =>(
                    this.listaCategoria = response.data
                ))
                .catch(error => {
                    console.log(error)
                })
            },
            sendOP(){
                if(this.loadOrdenPago()){
                    axios
                    .post(process.env.VUE_APP_API_URL + "ordenpago/insertar",{
                        token: this.$store.getters.userToken,
                        serie: this.listaSeries[this.indexSerie],
                        ordenpago: this.ordenpago,
                        pagado: 0,
                        idMovil:this.idMovil
                    })
                    .then(response=>(
                       this.$snotify.success(response.data.msg,'Exito'),
                         this.initOP(),
                         this.initTicket()
                    ))
                    .catch(error => {
                        this.$snotify.error(error.response.data.msg,'Error')
                    })
                }
            },
            loadOrdenPago: function () {
                this.ordenpago.receptor.tipo = this.tipoDocumento
                this.ordenpago.receptor.nro = this.receptor.numero
                this.ordenpago.receptor.razonSocial = this.receptor.razonSocial
                this.ordenpago.receptor.direccionFiscal = this.receptor.direccion
                this.ordenpago.moneda = this.moneda
                this.ordenpago.plazoentrega = this.plazoentrega
                this.ordenpago.formapago = this.tipoPago
                this.ordenpago.garantia = this.garantia
                this.ordenpago.telefono = this.telefono
                this.ordenpago.items = this.items
                this.ordenpago.totales = this.totales
                this.ordenpago.atencion = this.atencion
                this.ordenpago.observaciones = this.observaciones
                this.ordenpago.adicional.username = this.$store.getters.userData.username
                this.ordenpago.adicional.tipo_igv = this.igvGlobal
                this.ordenpago.sistema = this.sistema
                this.ordenpago.tag3 = this.tag3.tag

                return true
            },
            initOP: function () {
                this.ordenpago.receptor.tipo = ''
                this.ordenpago.receptor.nro = ''
                this.ordenpago.receptor.razonSocial = ''
                this.ordenpago.receptor.direccionFiscal = ''
                this.ordenpago.moneda = ''
                this.ordenpago.plazoentrega = ''
                this.ordenpago.formapago = ''
                this.ordenpago.garantia = ''
                this.ordenpago.telefono = ''
                this.ordenpago.atencion = ''
                this.ordenpago.observaciones = ''
                this.ordenpago.adicional = {}
                this.tipoDocumento = '0'
                this.items = []
                return true
            },
            listTag: function() {
            axios
              .post(process.env.VUE_APP_API_URL + "tag/listar", {
                token: this.$store.getters.userToken,
                limit: "40",
                order: "desc"
              })
              .then(
                response => (
                  (this.listaTag = response.data.data)
                )
              )
              .catch(error => (this.$snotify.error("Error")));
            },
            pagosImg(valor){
                this.monederoPago = valor;
                valor == 1 ? this.colorPago1 = true : this.colorPago1 = false;
                valor == 2 ? this.colorPago2 = true : this.colorPago2 = false;
                valor == 3 ? this.colorPago3 = true : this.colorPago3 = false;
                valor == 4 ? this.colorPago4 = true : this.colorPago4 = false;
                valor == 5 ? this.colorPago5 = true : this.colorPago5 = false;
                valor == 6 ? this.colorPago6 = true : this.colorPago6 = false;
                valor == 7 ? this.colorPago7 = true : this.colorPago7 = false;
                valor == 8 ? this.colorPago8 = true : this.colorPago8 = false;
                if(valor == 1){
                this.formadepago.codigo = this.formaPago[9].codigo;
                this.formadepago.nombre = this.formaPago[9].nombre;
                }else if(valor == 2){
                this.formadepago.codigo = this.formaPago[9].codigo;
                this.formadepago.nombre = this.formaPago[9].nombre;
                }else if(valor == 3){
                this.formadepago.codigo = this.formaPago[8].codigo;
                this.formadepago.nombre = this.formaPago[8].nombre;
                this.modalCredito = true;
                }else if(valor == 4){
                this.formadepago.codigo = this.formaPago[2].codigo;
                this.formadepago.nombre = this.formaPago[2].nombre;
                }else if(valor == 5){
                this.formadepago.codigo = this.formaPago[0].codigo;
                this.formadepago.nombre = this.formaPago[0].nombre;
                }else if(valor == 6){
                this.formadepago.codigo = this.formaPago[3].codigo;
                this.formadepago.nombre = this.formaPago[3].nombre;
                }else if(valor == 7){
                this.formadepago.codigo = this.formaPago[6].codigo;
                this.formadepago.nombre = this.formaPago[6].nombre;
                }else if(valor == 8){
                this.formadepago.codigo = this.formaPago[9].codigo;
                this.formadepago.nombre = this.formaPago[9].nombre;
                }
            },
            reciveLista(row, index, value ){
                if(row.detailsShowing){
                    row.toggleDetails()
                    this.products[index].reciveLista = false
                }else{
                    this.products[index].reciveLista = true
                    row.toggleDetails()
                    this.reciveajuste = value;
                }       
            },
            send_message() {
                if(this.numberwsp && this.numberwsp.trim() !== ''){
                    if(this.numberwsp.length == 9){
                        const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                        const {
                            idEmisor,
                            codigoComprobante,
                            serie,
                            numero,
                            idReceptor,
                            importeTotal
                        } = this.dataImpresionWsp
                        const mensaje = 'Comprobante' + ' ' +this.dataImpresionWsp.serie +'-'+ this.dataImpresionWsp.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                        const cadena = `${idEmisor}|${codigoComprobante}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                        const text = `${url}.${btoa(cadena)}+${mensaje}`
                        window.open(`https://wa.me/+51${this.numberwsp}?text=${text}`, '_blank')
                    }else{
                        this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
                    }
                }else{
                    this.$snotify.warning("DEBE INGRESAR NUMERO CELULAR")
                }
            },
            retencionIgv(){
                console.log('entro')
                let retencionigv = {
                    indicador: "",
                    codigoCargoDescuento: "",
                    factorCargoDescuento:"",
                    montoCargoDescuento: "",
                    baseCargoDescuento: ""
                }
                retencionigv.indicador = "descuento";
                retencionigv.codigoCargoDescuento = "62";
                retencionigv.factorCargoDescuento = parseFloat(0.03);
                retencionigv.montoCargoDescuento = parseFloat(((retencionigv.factorCargoDescuento * this.totales.importeTotal)).toFixed(2));
                retencionigv.baseCargoDescuento = parseFloat(this.totales.importeTotal.toFixed(2));
                this.cargosDescuentosGlobales.push(retencionigv)
            }
        }
    }
</script>

<style>
    .lineader{
        border-right: 4px solid #ccc;
        padding-right: 30px;
    }
    .address{
      height: 35px !important;
      margin: 0 !important;
    }
    .minimo{
        width: 100%;
        height: 410px;
    }
    table.my-table-scroll,
table.my-table-scroll > thead,
table.my-table-scroll > tbody,
table.my-table-scroll > tfoot,
table.my-table-scroll > tbody > tr,
table.my-table-scroll > thead > tr {
  width: 100%;
  display: block
}
table.my-table-scroll > thead,
table.my-table-scroll > tbody,
table.my-table-scroll > tfoot {
  display: block;
  width: 100%;
  overflow-y: scroll;
}
table.my-table-scroll > thead,
table.my-table-scroll > tfoot {
  height: auto;
}
/* these last two rules you will need to tweak on an as needed basis */
table.my-table-scroll > tbody {
  /* set max height for tbody before it scrolls */
  max-height: 500px;
}
table.my-table-scroll > thead > tr > th,
table.my-table-scroll > thead > tr > td,
table.my-table-scroll > tbody > tr > th,
table.my-table-scroll > tbody > tr > td,
table.my-table-scroll > tfoot > tr > th,
table.my-table-scroll > tfoot > tr > td {
  display: inline-block;
  /* you need to explicitly specify the width of the table cells */
  /* either equal, or specify individual widths based on col index. */
  /* Here, we assume you have 4 columns of data */
  width: 25%;
}
/*
  could use sibling selectors to select specific columns for widths:
  td + td (second column)
  td + td + td (3rd column, etc)
*/
</style>

<style>
  .form-label-group {
  position: relative;
  /* margin-bottom: 1rem; */
}

.form-label-group > input,
.form-label-group > label {
  height: 3.125rem;
  padding: .75rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 9px;
  color: #00B261;
}
.searcher-field{
  z-index: 1000;
  position: absolute;
  max-height: 400px !important;
  overflow-y: scroll;
  width: 500px
}
.searcher-result{
  font-size: smaller;
  padding: 2px 0px 2px 0px;
  cursor: pointer;
}
.sinresultados{
    padding: 0 5px 0 5px;  
}
.bordes{
    height: 100%;
    margin-top: 10px;
    border: 2px solid #ccc;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
}
.pagos{
    min-height: 320px;
    width: 100%;
}
.letra{
    font-size:100%
}
.negrita{
    border-color:#7e8fb9;
    color: black;
    font-size: 17px;
    font-family:'Arial';

}
.list-group-item {
    padding: 0px;
    margin: 0px;
    background-color: #fff;
    border: none;
}
.listaproducto{
    display: inline-block;
}
.detalleproducto{
    font-size: 10px;
}
.carritovacio{
    text-align: center;
    color: #838383;
}
.pdvtotales{
    margin-top: 10%;
    margin-right: 2%;
    margin-left: 20%;
    width: 68%;
    height: 100px;
    border-top: 3px solid #ccc;
    text-align: left;
    color: #838383;
}
.subtotales{
    text-align: right;
}
.scrollItems{
    height: 700px;
    width: 99%;
    position: relative; 
    overflow-y: scroll; 
    color: black;
}
.formasPagosImg{
width: 30%;
height: 40%;
border-radius:30px;
cursor: pointer;
}
.colorBorde{
  border-color:#7e8fb9;
}
</style>
